// extracted by mini-css-extract-plugin
export default {"bannerWrapper":"Baner_bannerWrapper__6MB-x","bannerImg":"Baner_bannerImg__lq74j","bannerDescription":"Baner_bannerDescription__JYMVm"};